module.exports = __webpack_public_path__ + "img/blue-circle-table-5.763f4654.png";